import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {KlinikaxpPaymentRequiredReservation} from "../klinikaxp-payment-required-reservation.model";

export class KlinikaXpPaymentRequiredReservationDgSearchResults extends GenericDgSearchResults {
  public results: KlinikaxpPaymentRequiredReservation[];

  constructor(total: number, results: KlinikaxpPaymentRequiredReservation[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
